import styled, { css } from "styled-components";

export const hw = {
    brand: "#DF0000",
    brandDark: "#B91C1C",
    brandSoft: "#FEF2F2",
    brandMuted: "#FEE2E2",
    text: "#0F172A",
    textMuted: "#64748B",
    textSubtle: "#94A3B8",
    border: "#E2E8F0",
    bg: "#F8FAFC",
    surface: "#FFFFFF",
    nav: "#0F172A",
    navHover: "rgba(255, 255, 255, 0.08)",
    success: "#16A34A",
    warning: "#DC2626",
    radius: "12px",
    radiusSm: "8px",
    shadow: "0 1px 2px rgba(15, 23, 42, 0.05), 0 8px 24px rgba(15, 23, 42, 0.04)",
};

export const scrollbar = css`
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: #F1F5F9;
    }
    &::-webkit-scrollbar-thumb {
        background: #CBD5E1;
        border-radius: 3px;
    }
`;

export const SettingCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px 24px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: ${hw.radius};
    box-shadow: ${hw.shadow};
`;

export const SettingTitle = styled.div`
    color: ${hw.text};
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const SettingGroupWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const SettingGroup = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 20px;
    padding: 12px 14px;
    border-radius: ${hw.radiusSm};
    border: 1px solid ${hw.border};
    background: ${hw.bg};
`;

export const SettingLabelWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SettingLabel = styled.label`
    color: ${hw.text};
    font-size: 14px;
    font-weight: 500;
    min-width: 84px;
`;

export const SettingCheck = styled.input`
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: ${hw.brand};
    cursor: pointer;

    &:disabled {
        cursor: default;
        opacity: 0.7;
    }
`;

export const SettingSelect = styled.select`
    color: ${hw.text};
    font-size: 14px;
    font-weight: 500;
    padding: 8px 12px;
    border: 1px solid ${hw.border};
    border-radius: ${hw.radiusSm};
    background: ${hw.surface};
    min-width: 140px;

    &:focus {
        outline: none;
        border-color: ${hw.brand};
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }

    &:disabled {
        color: ${hw.textSubtle};
        background: #F1F5F9;
        cursor: not-allowed;
    }
`;

export const ContentShell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    flex-grow: 1;
    min-height: 0;
    padding: 20px 24px 24px;
    overflow: hidden;
`;

export const Panel = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
    overflow: hidden;
`;

export const PanelHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    border-bottom: 1px solid ${hw.border};
    background: ${hw.surface};
`;

export const PanelTitle = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: ${hw.text};
    letter-spacing: -0.02em;
`;

export const CountBadge = styled.span`
    font-size: 12px;
    font-weight: 700;
    color: ${hw.brand};
    background: ${hw.brandSoft};
    padding: 4px 10px;
    border-radius: 999px;
`;

export const EmptyBadge = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${hw.textSubtle};
    background: ${hw.bg};
    border: 1px solid ${hw.border};
    padding: 3px 8px;
    border-radius: 6px;
    white-space: nowrap;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex: 1;
    min-height: 280px;
    padding: 48px 24px;
    text-align: center;
`;

export const EmptyTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${hw.text};
`;

export const EmptyText = styled.div`
    font-size: 13px;
    color: ${hw.textMuted};
    line-height: 1.5;
`;

export const ViewerTable = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    min-height: 0;
`;

export const ViewerHeader = styled.div`
    display: flex;
    background: #FAFBFC;
    border-bottom: 1px solid ${hw.border};
    position: sticky;
    top: 0;
    z-index: 1;
`;

export const ViewerCol = styled.div`
    text-align: left;
    padding: 14px 16px;
    font-size: 13px;
    color: ${hw.textMuted};
    font-weight: 600;
    display: flex;
    align-items: center;
    min-width: 0;
`;

export const ViewerRow = styled.div`
    display: flex;
    border-bottom: 1px solid ${hw.border};
    background: ${hw.surface};
    transition: background 0.15s ease;

    &:nth-child(even) {
        background: #FCFCFD;
    }

    &:hover {
        background: ${hw.brandSoft};
    }

    ${ViewerCol} {
        color: ${hw.text};
        font-weight: 500;
        white-space: normal;
        line-height: 1.45;
    }
`;

export const ViewerBody = styled.div`
    flex: 1;
    min-height: 0;
    overflow: auto;
    ${scrollbar}
`;

export const ViewerIndex = styled.span`
    color: ${hw.textSubtle};
    font-variant-numeric: tabular-nums;
`;

export const ViewerStrong = styled.span`
    font-weight: 700;
    color: ${hw.text};
`;

export const ViewerThumb = styled.img`
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid ${hw.border};
`;

export const ViewerVideo = styled.video`
    width: 280px;
    min-width: 280px;
    height: 158px;
    flex-shrink: 0;
    object-fit: contain;
    border-radius: 8px;
    border: 1px solid ${hw.border};
    background: #0F172A;
`;

export const ViewerAudioBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    border-radius: 8px;
    background: ${hw.bg};
`;

export const ViewerPlayBtn = styled.img`
    cursor: pointer;
    width: 28px;
    height: 28px;
    padding: 4px;
    border-radius: 8px;
    background: white;
    border: 1px solid ${hw.border};

    &:hover {
        background: ${hw.brandSoft};
        border-color: ${hw.brandMuted};
    }
`;

export const ViewerOnBadge = styled.span`
    font-size: 12px;
    font-weight: 700;
    color: ${hw.brand};
    background: ${hw.brandSoft};
    padding: 4px 8px;
    border-radius: 6px;
`;

export const EditorHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    flex-shrink: 0;
`;

export const EditorTitle = styled.h2`
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: ${hw.text};
    letter-spacing: -0.02em;
`;

export const EditorDesc = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${hw.textMuted};
    line-height: 1.5;
`;

export const ActionBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 12px;
    box-shadow: ${hw.shadow};
    flex-shrink: 0;
`;

export const ActionHint = styled.span`
    font-size: 13px;
    color: ${hw.brand};
    font-weight: 500;
`;

export const TableEmpty = styled.div`
    padding: 36px 16px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
    line-height: 1.5;
`;

export const EditorShell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    flex-grow: 1;
    min-height: 0;
    padding: 20px 24px 24px;
    overflow: hidden;
`;

export const EditorBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow: auto;
    ${scrollbar}
`;

export const EditorTableWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
    overflow: hidden;
`;

export const EditorTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    flex-shrink: 0;
`;

export const EditorThead = styled.thead`
    width: 100%;
    background: #FAFBFC;
`;

export const EditorTbody = styled.tbody`
    width: 100%;
`;

export const EditorTfoot = styled.tfoot`
    background: #FAFBFC;
`;

export const EditorTrHead = styled.tr`
    background: #FAFBFC;
`;

export const EditorTr = styled.tr`
    &:nth-child(even) {
        background: #FCFCFD;
    }
    &:hover {
        background: ${hw.brandSoft};
    }
`;

export const EditorTd = styled.td`
    padding: 10px 8px;
    border-bottom: 1px solid ${hw.border};
    text-align: center;
    vertical-align: middle;
`;

export const EditorTh = styled.td`
    padding: 14px 8px;
    border-bottom: 1px solid ${hw.border};
    text-align: center;
    font-weight: 700;
    font-size: 13px;
    color: ${hw.textMuted};
    white-space: nowrap;
`;

export const EditorScroll = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    ${scrollbar}
`;

export const EditorInput = styled.input`
    width: 100%;
    padding: 8px 12px;
    background: transparent;
    border: 1px solid ${hw.border};
    border-radius: 6px;
    text-align: left;
    font-size: 14px;
    color: ${hw.text};
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${hw.brand};
        box-shadow: 0 0 0 2px rgba(223, 0, 0, 0.15);
    }

    &::placeholder {
        color: ${hw.textSubtle};
    }
`;

export const EditorIconBtn = styled.img`
    cursor: pointer;
    width: 28px;
    height: 28px;
    padding: 4px;
    border-radius: 6px;
    background: white;
    border: 1px solid ${hw.border};
    box-sizing: border-box;

    &:hover {
        background: ${hw.brandSoft};
        border-color: ${hw.brandMuted};
    }
`;

export const EditorCheck = styled.input`
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    accent-color: ${hw.brand};
`;

export const EditorThumb = styled.img`
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid ${hw.border};
    cursor: pointer;
`;

export const EditorVideoThumb = styled.video`
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid ${hw.border};
    cursor: pointer;
    background: #0F172A;
`;

export const EditorAudioRow = styled.div`
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
`;

export const BatchBackdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.5);
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 100;
    overflow-y: auto;
    padding: 32px 20px;
`;

export const BatchModal = styled.div`
    width: 1040px;
    max-width: 100%;
    max-height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 20px;
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
    overflow: hidden;
    margin: auto;
`;

export const BatchHeader = styled.div`
    padding: 22px 28px 16px;
    border-bottom: 1px solid ${hw.border};
    flex-shrink: 0;
`;

export const BatchTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: ${hw.text};
    letter-spacing: -0.02em;
`;

export const BatchDesc = styled.p`
    margin: 6px 0 0;
    font-size: 13px;
    color: ${hw.textMuted};
    line-height: 1.5;
`;

export const BatchBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px 24px;
    overflow-y: auto;
    min-height: 0;
    background: ${hw.bg};
    ${scrollbar}
`;

export const BatchSection = styled.div<{ $column?: boolean }>`
    display: flex;
    flex-direction: ${props => props.$column ? "column" : "row"};
    gap: 16px;
    background: ${hw.surface};
    padding: 16px;
    border-radius: 14px;
    border: 1px solid ${hw.border};

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const BatchFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    padding: 14px 24px;
    border-top: 1px solid ${hw.border};
    background: ${hw.surface};
    flex-shrink: 0;
`;
